// eslint-disable-next-line no-unused-vars
import * as bootstrap from 'bootstrap'; // Bootstrap
import 'src/styles/global.scss'; // CSS

// jQuery
import $ from 'jquery';
window.$ = window.JQuery = $;

// js-cookie
const Cookies = require('js-cookie');
window.Cookies = Cookies;

// GET parameter by name
const getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
window.getParameterByName = getParameterByName;

// Debouncer
const debounce = (func, time = 100) => {
    var timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, time, event);
    };
};
window.debounce = debounce;
